import React from 'react'
import { Trans } from '@lingui/react'

import OnboardingModal from '../../onboarding/OnboardingModal'

const UserOnboardingModalWelcome = ({ ...props }) => (
    <OnboardingModal
        title={<Trans id="Welcome" />}
        subTitle={
            <Trans id="Before we get started, we need a few details to setup your account" />
        }
        {...props}
    />
)

export default UserOnboardingModalWelcome
